export default "__VITE_ASSET__404b659c__"